const config = {
    flashUrl: "https://ct-data.daoyidh.com/flash",
    jigsawpuzzle: {
        directory: "jigsawpuzzle"
    },
    sevenwords: {
        directory: "sevenwords"
    },
    rearrangesentence: {
        directory: "rearrangesentence"
    },
    matchinggame: {
        directory: "matchinggame"
    },
    ratedolphin: {
        directory: "ratedolphin"
    },
    typingdefense: {
        directory: "typingdefense"
    },
    typinggame: {
        directory: "typinggame"
    }
};

export default config;
